import React, { Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { IMyListsProps } from "./myLists";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SuccessAlert } from "wbm-generic-components";
const MyLists = React.lazy(
  () =>
    import(
      /* webpackMode: "eager" */
      /* webpackChunkName: "slide-outs" */
      "./myLists"
    )
);

function MyListsWrapper(props: IMyListsProps) {
  const ErrorFallbackRender = (fallbackProps: FallbackProps): JSX.Element => {
    props.setOpen(false);

    return (
      <SuccessAlert
        timerLengthInMS={3500}
        danger
        dangerText="Please try again. If the problem persists, please call 1-888-WB-MASON."
        dangerAttentionText="An error has occurred!"
        onClickClose={fallbackProps.resetErrorBoundary}
      />
    );
  };
  return (
    <>
      {ServerSideService.isServerSide ? undefined : (
        <ErrorBoundary fallbackRender={ErrorFallbackRender}>
          <Suspense fallback={<></>}>
            <MyLists {...props} />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}

export default MyListsWrapper;
